import { v4 } from "uuid";

const newGuid = v4;

export {
    newGuid
}

export default {
    new: newGuid
};